(() => {
  const sessionCookieName = '_ga_PLT8QQN0CR';

  function readCookie(name) {
    const prefix = `${name}=`;
    return document.cookie.split('; ').find((item) => item.startsWith(prefix))?.slice(prefix.length) || '';
  }

  function clientId() {
    const match = decodeURIComponent(readCookie('_ga')).match(/^GA\d+\.\d+\.(\d+\.\d+)$/);
    return match?.[1] || '';
  }

  function landingUrl() {
    const key = 'ww_first_landing_url';
    try {
      if (!sessionStorage.getItem(key)) sessionStorage.setItem(key, window.location.href.slice(0, 500));
      return sessionStorage.getItem(key) || '';
    } catch {
      return window.location.href.slice(0, 500);
    }
  }

  function referrerHost() {
    try { return document.referrer ? new URL(document.referrer).hostname : ''; } catch { return ''; }
  }

  function setPrivateProperty(form, name, value) {
    if (!value) return;
    let input = form.querySelector(`input[name="properties[${name}]"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }
    input.value = value.slice(0, 500);
  }

  function attach(form) {
    if (!(form instanceof HTMLFormElement)) return;
    setPrivateProperty(form, '_ww_ga_client_id', clientId());
    setPrivateProperty(form, '_ww_ga_session_cookie', decodeURIComponent(readCookie(sessionCookieName)));
    setPrivateProperty(form, '_ww_landing_url', landingUrl());
    setPrivateProperty(form, '_ww_referrer_host', referrerHost());
  }

  function attachAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(attach);
  }

  document.addEventListener('DOMContentLoaded', () => {
    attachAll();
    window.setTimeout(attachAll, 2500);
  });
  document.addEventListener('shopify:section:load', attachAll);
  document.addEventListener('pointerdown', (event) => {
    const form = event.target.closest?.('form[action*="/cart/add"]');
    if (form) attach(form);
  }, true);
})();
